import React from "react";

import { Stack, Typography } from "@mui/material";

import { Theme } from "../../../../Style/Theme";

/**
 * Heading 2
 * font is quite large
 * font lineheight is also large
 * @param text : text to inside of the typography
 *
 */

export const Heading = ({
  text,
  icon,
  lineHeight,
  fontSize,
  letterSpacing,
}) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        color={Theme.palette.background.grayDark}
        fontWeight={700}
        fontSize={fontSize || "22px"}
        lineHeight={lineHeight || "28px"}
        fontStyle={"normal"}
        letterSpacing={letterSpacing || "0.35px"}
      >
        {text}
      </Typography>
    </WrapText>
  );
};
export const Heading1 = ({ text, icon }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        color={Theme.palette.background.grayDark}
        fontWeight={600}
        fontSize={"17px"}
        lineHeight={"22px"}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

/**
 * Heading 2
 * font is quite little when comparing heading type 1 and type 2
 * font lineheight is also reduced
 * @param text : text to inside of the typography
 *
 */

export const Heading2 = ({ text, icon,color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        color={color?color:Theme.palette.background.grayDark}
        fontWeight={600}
        fontSize={"16px"}
        lineHeight={"21px"}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

/**
 * Heading 2
 * font is small than type 1, type 2
 * font lineheight is line height also smaller than type 1 and type 2
 * @param text : text to inside of the typography
 *
 */

export const Heading3 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        color={color ? color : Theme.palette.background.grayDark}
        fontWeight={600}
        fontSize={"15px"}
        lineHeight={"20px"}
      >
        {text}
      </Typography>
    </WrapText>
  );
};
export const Heading4 = ({ text, icon, color, iconAlign }) => {
  return (
    <WrapText iconAlign={iconAlign} isIcon={icon ? true : false}>
      <Typography>{icon}</Typography>
      <Typography
        color={color || Theme.palette.background.grayDark}
        fontWeight={400}
        fontSize={"16px"}
        lineHeight={"21px"}
        letterSpacing={"-0.32px"}
      >
        {text}
      </Typography>
    </WrapText>
  );
};
export const Heading5 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        color={color || Theme.palette.background.grayDark}
        fontWeight={600}
        fontSize={"13px"}
        lineHeight={"18px"}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

const WrapText = ({ children, isIcon, iconAlign }) => {
  return (
    <span
      style={{
        display: "flex",
        alignItems: iconAlign || "center",
        gap: isIcon && "8px",
      }}
    >
      {children}
    </span>
  );
};

export const Heading6 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Stack direction={"row"}>
        <Typography
          color={color ? color : Theme.palette.background.grayDark}
          fontWeight={600}
          fontSize={"15px"}
          lineHeight={"20px"}
        >
          {text}
        </Typography>
        <Typography
          color={color ? color : Theme.palette.background.primaryRed}
          fontWeight={600}
          fontSize={"15px"}
          lineHeight={"20px"}
        >
          *
        </Typography>
      </Stack>
    </WrapText>
  );
};
